export default "__VITE_ASSET__728db360__"